import { apiClient } from './client';

export interface CollectionDataItem {
  id: number;
  created_at: string;
  updated_at: string;
  [key: string]: unknown;
}

export const collectionDataApi = {
  /**
    * Get all items from a collection
    * GET /tenants/:tenantSlug/collections/:collectionName/data
    */
  getAll: async (tenantSlug: string, collectionName: string): Promise<CollectionDataItem[]> => {
    return apiClient.get<CollectionDataItem[]>(`/tenants/${tenantSlug}/collections/${collectionName}/data`);
  },

  /**
    * Get a single item by ID
    * GET /tenants/:tenantSlug/collections/:collectionName/data/:id
    */
  getById: async (
    tenantSlug: string,
    collectionName: string,
    id: number
  ): Promise<CollectionDataItem> => {
    return apiClient.get<CollectionDataItem>(`/tenants/${tenantSlug}/collections/${collectionName}/data/${id}`);
  },

  /**
    * Create a new item in the collection
    * POST /tenants/:tenantSlug/collections/:collectionName/data
    */
  create: async (
    tenantSlug: string,
    collectionName: string,
    data: Record<string, unknown>
  ): Promise<CollectionDataItem> => {
    return apiClient.post<CollectionDataItem>(`/tenants/${tenantSlug}/collections/${collectionName}/data`, data);
  },

  /**
    * Duplicate an item in the collection
    * POST /tenants/:tenantSlug/collections/:collectionName/data/:id/duplicate
    */
  duplicate: async (
    tenantSlug: string,
    collectionName: string,
    id: number
  ): Promise<CollectionDataItem> => {
    return apiClient.post<CollectionDataItem>(`/tenants/${tenantSlug}/collections/${collectionName}/data/${id}/duplicate`, {});
  },

  /**
    * Update an item in the collection
    * PUT /tenants/:tenantSlug/collections/:collectionName/data/:id
    */
  update: async (
    tenantSlug: string,
    collectionName: string,
    id: number,
    data: Record<string, unknown>
  ): Promise<CollectionDataItem> => {
    return apiClient.put<CollectionDataItem>(`/tenants/${tenantSlug}/collections/${collectionName}/data/${id}`, data);
  },

  /**
    * Delete an item from the collection
    * DELETE /tenants/:tenantSlug/collections/:collectionName/data/:id
    */
  delete: async (
    tenantSlug: string,
    collectionName: string,
    id: number
  ): Promise<void> => {
    return apiClient.delete<void>(`/tenants/${tenantSlug}/collections/${collectionName}/data/${id}`);
  },
};
